import RestClient from "RestClient";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const restClient = new RestClient();

export const emailValidation = async (payload) => {
    const result = await restClient.get(`${BASE_URL}/users/validateEmail`,payload);
    return result;
}
export const emailValidationClient = async (payload) => {
    const result = await restClient.get(`${BASE_URL}/users/validateEmail1`,payload);
    return result;
}
export const doLogin = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/users/authenticate`, payload);
    const { data, status } = result;
    if (status) {
        return data;
    } else {
        return result;
    }

}

export const doRegister = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/users/register`,payload);
    return result;
}

export const checkIfLoggedIn = () => {
    const result = sessionStorage.getItem("userInfo");
    if (result) {
        return result;
    }
    return false;
};

export const doLogout = () => {
    sessionStorage.clear();
    return true;
};

export const requestResetPassword = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/users/requestPasswordReset`,payload);
    return result;
}

export const doResetPassword = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/users/doPasswordReset`,payload);
    return result;
}
export const getAgentAccessStatus = async (payload) => {
    const result = await restClient.get(`${BASE_URL}/users/agentAccessStatus`,payload);
    return result;
}
export const updateAgentAccessStatus = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/users/updateAgentAccessStatus`,payload);
    return result;
}
export const associateAgent = async (payload) => {
    const result = await restClient.put(`${BASE_URL}/users/associateAgent`,payload);
    return result;
}
export const associateBroker = async (payload) => {
    const result = await restClient.put(`${BASE_URL}/users/associateBroker`,payload);
    return result;
}
export const updateSubscription = async (payload) => {
    const result = await restClient.put(`${BASE_URL}/users/updateSubscription`,payload);
    return result;
}
export const getAgentClientCount = async (id) => {
    const result = await restClient.get(`${BASE_URL}/users/getAgentClientCount/${id}`);
    return result;
}
export const getBrokerAgentCount = async (id) => {
    const result = await restClient.get(`${BASE_URL}/users/getBrokerAgentCount/${id}`);
    return result;
}